
export const LOAD_UNIT_ENUM_DATA_IN_PROGRESS = "LOAD_UNIT_ENUM_DATA_IN_PROGRESS";
export const loadUnitEnumDataInProgress = () => ({
  type: LOAD_UNIT_ENUM_DATA_IN_PROGRESS,
});

export const LOAD_UNIT_ENUM_DATA_SUCCESS = "LOAD_UNIT_ENUM_DATA_SUCCESS";
export const loadUnitEnumDataSuccess = (data) => ({
  type: LOAD_UNIT_ENUM_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_UNIT_ENUM_DATA_FAILURE = "LOAD_UNIT_ENUM_DATA_FAILURE";
export const loadUnitEnumDataFailure = () => ({
  type: LOAD_UNIT_ENUM_DATA_FAILURE,
});

export const OPEN_UNITS_AND_ENUMS_DIALOG = "OPEN_UNITS_AND_ENUMS_DIALOG";
export const openUnitsAndEnumsDialog = () => ({
  type: OPEN_UNITS_AND_ENUMS_DIALOG,
});

export const CLOSE_UNITS_AND_ENUMS_DIALOG = "CLOSE_UNITS_AND_ENUMS_DIALOG";
export const closeUnitsAndEnumsDialog = () => ({
  type: CLOSE_UNITS_AND_ENUMS_DIALOG,
});

export const LOAD_UNIT_AND_ENUM_SINGLE_DATA = "LOAD_UNIT_AND_ENUM_SINGLE_DATA";
export const loadUnitAndEnumSingleData = (data) => ({
  type: LOAD_UNIT_AND_ENUM_SINGLE_DATA,
  payload: { data },
});

export const UNIT_ENUM_OPERATION_COMPLETED = "UNIT_ENUM_OPERATION_COMPLETED";
export const unitEnumOperationCompleted = () => ({
  type: UNIT_ENUM_OPERATION_COMPLETED,
});